module.exports = __webpack_public_path__ + "static/media/bg1.8150a6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/bg1.png
// module id = 515
// module chunks = 0